import { AbstractControl, ValidationErrors } from '@angular/forms';
import DOMPurify from 'dompurify';

export class XSSValidator {
  static sanitize(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (typeof value === 'string') {
      const sanitized = DOMPurify.sanitize(value);
      return value !== sanitized ? { 'string.xssDetected': true } : null;
    }
    return null;
  }
}
